$(function() {
  let $appDownloadPopup = $('#app-download-popup');

  if ($appDownloadPopup.length) {
    $appDownloadPopup.modal('show');
  }
});
